export default __webpack_public_path__ + "static/P22MackinacPro-Book-b9576f72df072adfc6e0701ed67adf5a.woff2";